import type { _AssetMap } from '../types/empty-state-types.js';

export const EMTPY_STATE_ASSET_MAP: _AssetMap = {
  chart: {
    'create-new': {
      dark: 'https://dt-cdn.net/images/chart-create-new-dark-052d72ca30.svg',
      light: 'https://dt-cdn.net/images/chart-create-new-light-c385b5fdff.svg',
    },
    'no-permission': {
      dark: 'https://dt-cdn.net/images/chart-no-permission-dark-6ffe51ec61.svg',
      light:
        'https://dt-cdn.net/images/chart-no-permission-light-7272fa74c3.svg',
    },
    'no-result': {
      dark: 'https://dt-cdn.net/images/chart-no-result-dark-78abbbd85b.svg',
      light: 'https://dt-cdn.net/images/chart-no-result-light-7f9c5ef30b.svg',
    },
    'something-missing': {
      dark: 'https://dt-cdn.net/images/chart-something-missing-dark-3853b17f8f.svg',
      light:
        'https://dt-cdn.net/images/chart-something-missing-light-6dc0e87402.svg',
    },
    'something-wrong': {
      dark: 'https://dt-cdn.net/images/chart-something-wrong-dark-956491d9cd.svg',
      light:
        'https://dt-cdn.net/images/chart-something-wrong-light-b624204eb3.svg',
    },
  },
  table: {
    'create-new': {
      dark: 'https://dt-cdn.net/images/table-create-new-dark-ba0624b149.svg',
      light: 'https://dt-cdn.net/images/table-create-new-light-db7f37f641.svg',
    },
    'no-permission': {
      dark: 'https://dt-cdn.net/images/table-no-permission-dark-e5383630bd.svg',
      light:
        'https://dt-cdn.net/images/table-no-permission-light-49a61e414f.svg',
    },
    'no-result': {
      dark: 'https://dt-cdn.net/images/table-no-result-dark-68a45d7852.svg',
      light: 'https://dt-cdn.net/images/table-no-result-light-0aea1a1233.svg',
    },
    'something-missing': {
      dark: 'https://dt-cdn.net/images/table-something-missing-dark-2b7a944985.svg',
      light:
        'https://dt-cdn.net/images/table-something-missing-light-640af56f7d.svg',
    },
    'something-wrong': {
      dark: 'https://dt-cdn.net/images/table-something-wrong-dark-e789ecd0e0.svg',
      light:
        'https://dt-cdn.net/images/table-something-wrong-light-5d933b4dac.svg',
    },
  },
  query: {
    'create-new': {
      dark: 'https://dt-cdn.net/images/query-create-new-dark-82ba18a9bf.svg',
      light: 'https://dt-cdn.net/images/query-create-new-light-e795090014.svg',
    },
    'no-permission': {
      dark: 'https://dt-cdn.net/images/query-no-permission-dark-4598cbacd3.svg',
      light:
        'https://dt-cdn.net/images/query-no-permission-light-5996cb4f2b.svg',
    },
    'no-result': {
      dark: 'https://dt-cdn.net/images/query-no-result-dark-40a6b9b832.svg',
      light: 'https://dt-cdn.net/images/query-no-result-light-472b0a5ccb.svg',
    },
    'something-missing': {
      dark: 'https://dt-cdn.net/images/query-something-missing-dark-76b18c3e92.svg',
      light:
        'https://dt-cdn.net/images/query-something-missing-light-9ddea8be81.svg',
    },
    'something-wrong': {
      dark: 'https://dt-cdn.net/images/query-something-wrong-dark-e930a45cdf.svg',
      light:
        'https://dt-cdn.net/images/query-something-wrong-light-3b51b5fc41.svg',
    },
  },
  generic: {
    'create-new': {
      dark: 'https://dt-cdn.net/images/generic-create-new-dark-ee2258fd2f.svg',
      light:
        'https://dt-cdn.net/images/generic-create-new-light-885921ab40.svg',
    },
    'no-permission': {
      dark: 'https://dt-cdn.net/images/generic-no-permission-dark-817a91781b.svg',
      light:
        'https://dt-cdn.net/images/generic-no-permission-light-bdf50c89b0.svg',
    },
    'no-result': {
      dark: 'https://dt-cdn.net/images/generic-no-result-dark-aa0f7a1435.svg',
      light: 'https://dt-cdn.net/images/generic-no-result-light-dc891bc14d.svg',
    },
    'something-missing': {
      dark: 'https://dt-cdn.net/images/generic-something-missing-dark-1d769c3754.svg',
      light:
        'https://dt-cdn.net/images/generic-something-missing-light-d74815c548.svg',
    },
    'something-wrong': {
      dark: 'https://dt-cdn.net/images/generic-something-wrong-dark-cd26ed6f77.svg',
      light:
        'https://dt-cdn.net/images/generic-something-wrong-light-1c3eb8823e.svg',
    },
  },
  document: {
    'create-new': {
      dark: 'https://dt-cdn.net/images/document-create-new-dark-3ed278ab63.svg',
      light:
        'https://dt-cdn.net/images/document-create-new-light-5d0ca29520.svg',
    },
    'no-permission': {
      dark: 'https://dt-cdn.net/images/document-no-permission-dark-a5132e3ad2.svg',
      light:
        'https://dt-cdn.net/images/document-no-permission-light-7dfb08b045.svg',
    },
    'no-result': {
      dark: 'https://dt-cdn.net/images/document-no-result-dark-0e253a7131.svg',
      light:
        'https://dt-cdn.net/images/document-no-result-light-f846cec211.svg',
    },
    'something-missing': {
      dark: 'https://dt-cdn.net/images/document-something-missing-dark-4da05df220.svg',
      light:
        'https://dt-cdn.net/images/document-something-missing-light-759cc146d7.svg',
    },
    'something-wrong': {
      dark: 'https://dt-cdn.net/images/document-something-wrong-dark-9af73b5988.svg',
      light:
        'https://dt-cdn.net/images/document-something-wrong-light-d11398e80a.svg',
    },
  },
};
